var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"flex mt-8"},[_c('side-bar'),_c('div',{staticClass:"lg:flex-1 bg-white rounded mr-1 sm:w-full sm:-ml-1 lg:-ml-0 m-auto"},[(_vm.showAppointmentsComponent)?_c('appointments'):_vm._e(),(_vm.showNotificationsComponent)?_c('notification'):_vm._e(),(_vm.showPasswordComponent)?_c('password'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }